import { ComponentFactoryResolver, NgModule, Type } from '@angular/core';
import { Routes, RouterModule, Router, NavigationEnd } from '@angular/router';


import { LoginComponent } from './views/login/login.component';
import { MainComponent } from './views/main/main.component';
import { AnaUtentiComponent } from './views/ana-utenti/ana-utenti.component';
//import { AnaProduttoriComponent } from './views/ana-produttori/ana-produttori.component';
//import { AnaTrasportatoriComponent } from './views/ana-trasportatori/ana-trasportatori.component';
//import { AnaSmaltitoriComponent } from './views/ana-smaltitori/ana-smaltitori.component';
import { EmailComponent } from './widgets/email/email.component';
import { OwnerComponent } from './views/main/owner/owner.component';
import { DashboardComponent } from './views/dashboard/dashboard.component';
import { NicaMenuService } from './services/nica-menu.service';
import { AnacomuniComponent } from './components/anagrafiche/anacomuni/anacomuni.component';
import { CerComponent } from './components/anagrafiche/cer/cer.component';
//import { TrasportatoriComponent } from './components/anagrafiche/trasportatori/trasportatori.component';

import { Breadcrumb } from './class/appinterface';
import { Utenteservice } from './services/utente.service';
import { DashboardTabsComponent } from './views/dashboard/dashboard-tabs/dashboard-tabs.component';
import { RentriComponent } from './views/rentri/rentri.component';
import { AnaSoggettoComponent } from './views/ana-soggetto/ana-soggetto.component';
import { AnagraficaGridComponent } from './views/ana-grid/ana-grid.component';
import { GenerateFormComponent } from './components/generate-form/generate-form.component';
import { HomepageComponent } from './components/homepage/homepage.component';
import { VivifirComponent } from './components/vivifir/vivifir.component';
import { FormulariRentriComponent } from './views/rentri/formulari/formulari-rentri.component';
import { MovimentiComponent } from './views/rentri/movimenti/movimenti.component';
import { NicaModelloStampaComponent } from './widgets/nica-modello-stampa/nica-modello-stampa.component';
import { ExcelExporterComponent } from './components/shared/excel-exporter/excel-exporter.component';
import { AnaAutomezzoComponent } from './views/ana-automezzo/ana-automezzo.component';
import { AnaAlboComponent } from './views/ana-albo/ana-albo.component';
import { AnaAutorizzazioneComponent } from './views/ana-autorizzazione/ana-autorizzazione.component';
import { AnaUnitaLocaliComponent } from './views/ana-soggetto/ana-unita-locali/ana-unita-locali.component';
import { CausalirifiutiComponent } from './views/causalirifiuti/causalirifiuti.component';
import { RegistririfiutiComponent } from './components/registririfiuti/registririfiuti.component';
import { HomepagewwComponent } from './components/homepageww/homepageww.component';
import { MovimentiCaricoScaricoComponent } from './views/movimenti-carico-scarico/movimenti-carico-scarico.component';
import { StampaRegistriCaricoScaricoComponent } from './views/stampa-registri-carico-scarico/stampa-registri-carico-scarico.component';
import { SchedarifiutiComponent } from './views/schedarifiuti/schedarifiuti.component';

import { GruppiComponent } from './components/gruppi/gruppi.component';
import { NicaDataGridComponent } from './components/nica-data-grid/nica-data-grid.component';
import { EmissioneFormulariComponent } from './views/emissione-formulari/emissione-formulari.component';
import { AnaMagazziniComponent } from './views/ana-magazzini/ana-magazzini.component';
import { AnaAutistiComponent } from './views/ana-autisti/ana-autisti.component';
import { AnaCantieriComponent } from './views/ana-cantieri/ana-cantieri.component';
import { AnaLottiComponent } from './views/ana-lotti/ana-lotti.component';
import { AnaSchedaRifiutiComponent } from './views/ana-scheda-rifiuti/ana-scheda-rifiuti.component';
import { AnaRegistriRifiutiComponent } from './views/ana-registri-rifiuti/ana-registri-rifiuti.component';
import { GiacenzeRifiutiComponent } from './views/giacenze/giacenze-rifiuti.component';
import { StatisticheRifiutiComponent } from './views/statistiche-rifiuti/statistiche-rifiuti.component';
import { WidgetGraficiComponent } from './components/widget-grafici/widget-grafici.component';
import { StatisticarifiutiGraficiComponent } from './views/statisticarifiuti-grafici/statisticarifiuti-grafici.component';
import { ShowRentriComponent } from './components/show-rentri/show-rentri.component';
import { TestComponent } from './components/test/test.component';
import { CrmComponent } from './views/crm/crm.component';
import { GestioneFormulariComponent } from './views/gestione-formulari/gestione-formulari.component';
//import { StatisticheRifiutiComponent } from './views/statistiche-rifiuti/statistiche-rifiuti.component';
//import { AnaRegistroRifiutiComponent } from './views/ana-registro-rifiuti/ana-registro-rifiuti.component';



const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    data: { title: 'Login' },

  },

  {
    path: 'main',
    component: MainComponent,
    data: { breadcrumb: 'Main' },
    canActivate: [Utenteservice],
    //loadChildren: () => import('./views/main/main.module').then(m => m), nn va!!!!
    children: [

      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'main'
      },
      {
        path: 'home',
        //component: HomepageComponent
        component: HomepagewwComponent
      },
      {
        path: 'home-2',
        //component: HomepageComponent
        component: DashboardComponent
      },
      {
        path: 'dashboard',
        component: DashboardComponent
      },
      //
      {
        path: 'gruppi',
        //component: HomepageComponent
        component: GruppiComponent
      },
      {
        path: 'gestione-utenti',
        //component: HomepageComponent
        component: AnaUtentiComponent
      },
      {
        path: 'archivio-comuni-ditalia',
        //component: HomepageComponent
        component: AnacomuniComponent
      },
      {
        path: 'catalogo-europeo-rifiuti-eer',
        //component: HomepageComponent
        component: CerComponent
      },
      {
        path: 'genera-anagrafica',
        component: GenerateFormComponent,
        data: { title: 'Login' },

      },
      {
        path: 'anagrafiche-propri-impianti',
        component: AnaSoggettoComponent,

      },
      {
        path: 'anagrafiche-operatori',
        component: AnaSoggettoComponent,

      },
      {
        path: 'anagrafica-magazzini',
        component: AnaMagazziniComponent,

      },
      {
        path: 'anagrafica-autisti',
        component: AnaAutistiComponent,

      },
      {
        path: 'anagrafica-automezzo',
        component: AnaAutomezzoComponent,

      },
      {
        path: 'anagrafica-lotti',
        component: AnaLottiComponent,

      },
      {
        path: 'anagrafica-cantieri',
        component: AnaCantieriComponent,

      },
      {
        path: 'anagrafica-albo',
        component: AnaAlboComponent,

      },
      {
        path: 'anagrafica-autorizzazione',
        component: AnaAutorizzazioneComponent,

      },
      {
        path: 'anagrafica-unita-locali-ns',
        component: AnaUnitaLocaliComponent,

      },
      {
        path: 'anagrafica-unita-locali',
        component: AnaUnitaLocaliComponent,

      },

      {
        path: 'configurazione-causali-gestione-rifiuti',
        component: CausalirifiutiComponent,

      },
      {
        path: 'stampa-registri-di-carico-e-scarico-aziendali',
        component: StampaRegistriCaricoScaricoComponent,

      },
      {
        path: 'anagrafica-magazzini',
        component: AnaMagazziniComponent,

      },
      {
        path: 'registro-carico-e-scarico-rifiuti',
        component: MovimentiCaricoScaricoComponent,

      },
      {
        path: 'xfir-formulari-identificazione-rifiuti',
        component: EmissioneFormulariComponent,

      },
      /* {
          path: 'configurazione-registri-di-cs-rifiuti',
          component: RegistririfiutiComponent,
          
      }, */
      {
        path: 'configurazione-registri-di-cs-rifiuti',
        component: AnaRegistriRifiutiComponent,

      },

      {
        path: 'statistiche-rifiuti',
        component: StatisticheRifiutiComponent,
      },
      {
        path: 'statistiche-rifiuti-grafici',
        component: StatisticarifiutiGraficiComponent,
      },
      {
        path: 'grafici',
        component: WidgetGraficiComponent,
      },
      {
        path: 'modelli-di-stampa',
        component: NicaModelloStampaComponent,
        data: { title: 'Login' },

      },
      {
        path: 'excel',
        component: ExcelExporterComponent,
        data: { title: 'Login' },

      },
      {
        path: 'catalogo-europeo-rifiuti-err',
        component: CerComponent,


      },
      {
        path: 'schede-descrittive-rifiuti',
        component: SchedarifiutiComponent,


      },
      {
        path: 'crm-per-il-momento',
        component: CrmComponent,
      },
      {
        path: 'ana-schede-descrittive-rifiuti',
        component: AnaSchedaRifiutiComponent,


      },
      {
        path: 'giacenze-rifiuti',
        component: GiacenzeRifiutiComponent,


      },
      {
        path: 'rentri',
        component: RentriComponent,
        data: { title: 'Rentri formulai' },

      },
      {
        path: 'fir-digitali',
        component: GestioneFormulariComponent,
        data: { title: 'FIR Digitali' },

      },
      {
        path: 'rentri-formulari',
        component: FormulariRentriComponent,
        data: { title: 'Rentri formulai' },

      },
      {
        path: 'rentri-movimenti',
        component: MovimentiComponent,
        data: { title: 'Rentri movimenti' },

      },

      {
        path: 'modello-stampa',
        component: NicaModelloStampaComponent,
        data: { title: 'Modello stampa' },

      },

      /************TEST*****************/

      {
        path: 'area-test-sandbox',
        component: TestComponent
      },


      /************FINE TEST**************** */

      {
        path: 'anagrafica-produttori-detentori',
        component: AnagraficaGridComponent,
        data: { title: 'anagrafica produttori' },
      },



      {
        path: 'email',
        component: EmailComponent,
        data: { breadcrumb: 'Email' },
      },


    ]
  },

  { path: '', redirectTo: '/main', pathMatch: 'full' }, // redirect to 
  {
    path: 'owner',
    component: OwnerComponent,
    canActivate: [Utenteservice],
    data: { title: 'Owner Dashboard' },
  },
  {
    path: 'showRentri',
    component: ShowRentriComponent,
    canActivate: [Utenteservice],
    data: { title: 'showRentri Dashboard' },
  },
  {
    path: 'rentri',
    component: RentriComponent,
    data: { title: 'Rentri formulai' },

  },
  {
    path: 'AnagraficaUtenti',
    //component: AnaUtentiComponent,
    data: { title: 'Anagrafica' },
    children: [
      {
        path: 'Email',
        component: EmailComponent,
        data: { title: 'Email' },
      },
      {
        path: 'AnagraficaUtenti',
        component: AnaUtentiComponent,
        data: { title: 'Utenti' },
      },/*{
                path: 'AnagraficaProduttori/:id',
                component: AnaProduttoriComponent,
                data: { title: 'Produttori' }
            },{
                path: 'AnagraficaTrasportatori/:id',
                component: AnaTrasportatoriComponent,
                data: { title: 'Trasportatori' }
            },{
                path: 'AnagraficaSmaltitori/:id',
                component: AnaSmaltitoriComponent,
                data: { title: 'Smaltitori' }
            }*/],
  },




];





@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload', useHash: true })],
  exports: [RouterModule],

})
export class AppRoutingModule {

  components: any = [];


  constructor(private menuService: NicaMenuService, private Router: Router, private _componentFactoryResolver: ComponentFactoryResolver) {

    this.components['AnacomuniComponent'] = AnacomuniComponent;
    this.components['CerComponent'] = CerComponent;
    //this.components['TrasportatoriComponent'] = TrasportatoriComponent;
    console.log('Router', this.Router)
    this.menuService.menuMain.subscribe(menu => {
      console.log(menu)
      this.createRouters(menu);

    })

  }

  createRouters(rotte, arrayItem = this.Router.config[1], k = 0) {

    for (let i = 0; i < rotte.length; i++) {

      if (rotte[i].items) {
        this.createRouters(rotte[i].items, arrayItem, i)

      } else {
        let path = rotte[i].text.toLowerCase().replace(/[^a-zA-Z ]/g, '');
        path = path.replace(/\s/g, '-');


        const factories = Array.from(this._componentFactoryResolver['_factories'].keys());
        const factoryClass = <Type<any>>factories.find((x: any) => x.name === rotte[i].controller);

        arrayItem.children.push(
          {
            path: path,
            component: factoryClass,
            data: { breadcrumb: (data: any) => `${path}` },

          }

        )


      }

    }


  }




}
